
const ItemSearchPackage = ({ item, index, selectItem, visibleColumns, renderers }) => (
    <tr className="orderRow" onClick={() => selectItem(item)}>
      {visibleColumns.map(col => (
        <td key={col.id}>
          {renderers[col.id]?.(item) || ''}
        </td>
      ))}
    </tr>
  );

export default ItemSearchPackage;